import { Species } from './species';

export class Disease {
    id: number | null = null;
    species: Species | null = null;
    name: string = '';
}